module.exports = __webpack_public_path__ + "img/87.52f6e63d.jpg";